import React from 'react';
import dayjs from "dayjs";
import {Formik} from "formik";
import ModalCommon from "../../../../common/components/ModalCommon";
import FieldDatepicker from "../../../../common/components/FieldDatepicker";
import FieldInput from "../../../../common/components/FieldInput";
import FieldTextareaAutosize from "../../../../common/components/FieldTextareaAutosize";
import view from '../../../../common/assets/visibility-4a4a4a.svg';
import styles from './styles.module.scss';

const PopupDetails = ({
                        city, street, blockParcel,
                        propertyDetails,
                        appraisalPurpose,
                        buildingRights,
                        plans,
                        comparisonTransactions,
                        determinedValue,
                        valuePerSqm,
                        coefficients,
                        appraisalAssumptions,
                        keyFindingsAndConclusions,
                        effectiveDate,
                        betterment,
                        levy
                      }) => {
  const fields = [
    {name: 'effectiveDate', label: 'מועד קובע', value: effectiveDate},
    {name: 'determinedValue', label: 'שווי שנקבע', value: determinedValue},
    {name: 'valuePerSqm', label: 'שווי למ"ר', value: valuePerSqm},

    {name: 'propertyDetails', label: 'פרטי הנכס', value: propertyDetails},
    {name: 'appraisalPurpose', label: 'מטרת השומה', value: appraisalPurpose},
    {name: 'buildingRights', label: 'זכויות בנייה', value: buildingRights},
    {name: 'plans', label: 'תוכניות', value: plans},
    {name: 'comparisonTransactions', label: 'עסקאות השוואה', value: comparisonTransactions},
    {name: 'betterment', label: 'השבחה', value: betterment},
    {name: 'levy', label: 'היטל', value: levy},
    {name: 'coefficients', label: 'מקדמים', value: coefficients},
    {name: 'appraisalAssumptions', label: 'הנחות שמאיות', value: appraisalAssumptions},
    {name: 'keyFindingsAndConclusions', label: 'נתונים מרכזיים + מסקנות', value: keyFindingsAndConclusions},
  ];
  const object = [city, street, blockParcel].filter(Boolean).join(' / ')

  return (
    <ModalCommon
      size={'xl'}
      header={[`נתח שומה`, object].filter(Boolean).join(' - ')}
      customModalTrigger={
        <div className={styles.viewItemContainer}>
          <img src={view ?? ''} alt="i"/><span>צפייה</span>
        </div>
      }
    >
      <Formik
        initialValues={{
          propertyDetails,
          appraisalPurpose,
          buildingRights,
          plans,
          comparisonTransactions,
          determinedValue,
          valuePerSqm,
          coefficients,
          appraisalAssumptions,
          keyFindingsAndConclusions,
          effectiveDate,
          betterment,
          levy
        }}
        onSubmit={() => {
        }}
      >
        <div className={styles.formContainer}>
          {fields.map((item, index) => {
            const {name, label, value} = item;
            const props = {
              key: index,
              fieldId: name,
              value: name === 'effectiveDate' ? dayjs(value) : value,
              label: label,
              disabled: true,
              boxStyles: styles.datepicker,
              datepickerStyles: styles.datepicker,
              minRows: 4,
              maxRows: 4,
              showBird: false
            }

            if (name === 'effectiveDate') {
              return <FieldDatepicker {...props}/>
            } else if (name === 'determinedValue' || name === 'valuePerSqm') {
              return <FieldInput {...props}/>
            } else {
              return <FieldTextareaAutosize {...props}/>
            }
          })}
        </div>
      </Formik>

    </ModalCommon>
  );
};

export default PopupDetails;